import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import videoback from '../Assets/videoback.webp';
import { FaPlay } from "react-icons/fa6";
import HeadingOfSections from './HeadingOfSection';

const VideoSection = (props) => {
    const { t } = useTranslation();
    const [isPlaying, setIsPlaying] = useState(false);
    const handlPlay = () => {
        setIsPlaying(!isPlaying);
    };
    
    return (
        <section name='about' className={`w-full flex flex-col gap-8 md:gap-14`}>
            <HeadingOfSections 
                header={t('homepage.videosection.title')}
                span={t('homepage.videosection.span')}
                text={t('homepage.videosection.description')}/>
            <div className='relative w-full aspect-[16/6]'>
                
                
                <div className={props.padd}>
                    <div className="relative w-full mx-auto ">
                        {/* Thumbnail Image */}
                        {isPlaying ? 
                            <div className='w-full  aspect-[16/6]'>
                                <iframe 
                                    className=''
                                    width="100%" 
                                    height="100%" 
                                    src="" 
                                    title="YouTube video player" 
                                    frameBorder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    referrerPolicy="strict-origin-when-cross-origin" 
                                    allowFullScreen
                                />
                            </div>
                          : <img
                          loading="lazy"
                          className="w-full  object-cover aspect-[16/6] "
                          src={videoback}  // Get thumbnail image
                          alt="YouTube Video"
                      /> 
                        }
                        {/* Play Button */}
                        {!isPlaying && 
                        <>

                            <div className='absolute left-0 top-0 bottom-0  w-1/2 bg-gradient-to-r from-secondary/60 to-transparent'></div>
                            <div className='bg-transparent border-white/50 border-[1px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20 p-3 rounded-full '>
                                <span
                                onClick={handlPlay}
                                    className="bg-white flex items-center justify-center h-full w-full rounded-full p-4 shadow-lg hover:bg-gray-200 transition"
                                >
                                    <FaPlay size={15} className='text-primary02'/>
                                </span>
                            </div>
                        </>

                        }
                    </div>
                </div>

            </div>
        </section>
    )
}

export default VideoSection